<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>{{ !edit ? "New" : "Edit" }} Annotation</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngAnnotationForm" #ngForm="ngForm" id="annotationForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>
                  <label
                    style="width: 65px; min-width: 65px;"
                    class="mt-1 mb-1"
                    for="">Name</label>
                  <input
                    style="width: calc(100% - 75px);min-width: calc(100% - 75px);"
                    class="mb-1"
                    required
                    maxlength="30"
                    [(ngModel)]="model.name"
                    type="string"
                    name="name"
                    id="name"
                  />
                </div>
                <div *ngIf="this.model.annotationType == 'Text'">
                  <label
                   style="width: 65px; min-width: 65px;"
                    class="mt-1 mb-1"
                    for="">Text to Display</label>
                  <input
                   style="width: calc(100% - 75px);min-width: calc(100% - 75px);"
                    class="mb-1"
                    maxlength="300"
                    [(ngModel)]="model.text"
                    type="string"
                    name="text"
                    id="text"
                    [required]="this.model.annotationType == 'Text'"
                  />
                </div>
              </div>
              <div class="input-fields">
                <div >
                  <label
                    style="width: 65px; min-width: 65px;"
                    class="mt-1 mb-1"
                    for="" *ngIf="this.model.annotationType != 'Text'">Line Width</label>
                  <label
                    style="width: 65px; min-width: 65px;"
                    class="mt-1 mb-1"
                    for="" *ngIf="this.model.annotationType == 'Text'">Font Size</label>
                  <input
                    class="mb-1"
                    maxlength="3"
                    [(ngModel)]="model.lineWidth"
                    type="number"
                    name="lineWidth"
                    id="lineWidth"
                    required
                  />
                  <span style="width: 6%" *ngIf="this.model.annotationType == 'Text'">pixels</span>
                </div>
                <div *ngIf="this.model.annotationType == 'Text'">
                  <label
                   style="width: 65px; min-width: 65px;"
                    class="mt-1 mb-1"
                    for="">Font</label>
                  <select
                    class="mb-1"
                    [(ngModel)]="model.font"
                    name="font"
                    id="font"
                    [required]="this.model.annotationType == 'Text'">
                  <option value="Arial">Arial</option>
                  <option value="Consolas">Consolas</option>
                  <option value="Monaco">Monaco</option>
                  <option value="monospace">monospace</option>
                  <option value="Roboto">Roboto </option>
                  <option value="sans-serif">sans-serif</option>
                  <option value="Times New Roman">Times New Roman</option>
                </select>
                  <!--<input
                    maxlength="200"
                    [(ngModel)]="model.font"
                    type="string"
                    name="font"
                    id="font"
                    [required]="this.model.annotationType == 'Text'"
                  />-->
                </div>
              </div>
              <div class="input-fields">
                <div style="justify-content: flex-start;">
                  <label
                    style="width: auto; min-width: 60px;"
                    class="mt-1 mb-1"
                    for="">Color</label>
                  <!-- <input
                    [style.background]="model.color"
                    [cpOKButton]="true"
                    [cpSaveClickOutside]="false"
                    [(colorPicker)]="model.color"
                    [cpOutputFormat]="'hex'"
                    [cpOKButtonClass]= "'blue'"
                    cpPosition="auto"
                    [cpPresetColors]="['#000000', '#808080', '#ff0000', '#00ff00', '#008000','#00FFFF', '#0000ff', '#800080']"
                    name="lineColor"
                    id="lineColor"
                  /> -->
                  <span style="width: auto;display: block;margin-right: 10px;">{{ model.color }}</span>
                  <input style="padding: 0px;" type="color" id="lineColor" name="lineColor" value={{model.color}} [(ngModel)]="model.color">
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="createAnnotation();" [disabled]="!ngForm.form.valid">
              <span *ngIf="!edit">Create</span>
              <span *ngIf="edit">Edit</span>
            </button>
            <button class="gray" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
